import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { AppRole } from '../types';
import { useAuth } from '../state/AuthContext';

export function RequireAuth({ children, allowedRoles }: { children: ReactNode; allowedRoles?: AppRole[] }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="page-loader">Piko is preparing your dashboardâ€¦</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/unauthorized" replace />;
  return <>{children}</>;
}


